export enum PriceKey {
    AdvancedAnnual = "omlet_advanced_annual",
    Free = "omlet_free",
    IntroMonthly = "omlet_intro_monthly",
    IntroAnnual = "omlet_intro_annual",
    ThousandComponentsAddonAnnual = "omlet_1k_component_annual",
    ThousandComponentsAddonMonthly = "omlet_1k_component_monthly",
}
